<template>
  <div class="distribution-card">
    <div class="flex-row-align-center">
      <h4 class="title">Distribution</h4>
      <expand />
      <div class="selection-chits">
        <span
          v-for="(item, index) in series"
          :key="index"
          @click="
            () => {
              showGraph = index;
            }
          "
          :class="[{ active: showGraph === index }]"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div id="chart">
      <apexchart
        v-for="series in getSeries"
        :key="series.name"
        type="bar"
        height="200"
        :options="chartOptions"
        :series="getSeries"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    series: Array,
  },
  data() {
    return {
      showGraph: 0,
    };
  },
  computed: {
    getSeries() {
      let series = this.series[this.showGraph];
      if (!series) return null;
      return [
        {
          name: series.name,
          xtitle: series.xtitle,
          data: series.data
            .map(item => {
              return {
                x: item[0],
                y: item[1],
              };
            })
            .filter(item => item.x !== null && item.y !== null),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          animations: {
            enabled: false,
          },
          type: "bar",
          height: 200,
          stacked: false,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              colors: "var(--font-color)",
            },
          },
          title: {
            // text: this.getSeries[0].xtitle,
          },
        },
        yaxis: {
          tickAmount: 6,
          labels: {
            style: {
              color: "var(--font-color)",
            },
            formatter: value => {
              return this.formatNumber(value);
            },
          },
        },
        fill: {
          opacity: 1,
          colors: [
            function({ value, seriesIndex, w }) {
              return "#00ffa4";
            },
          ],
        },
        tooltip: {
          show: true,
          enabled: true,
          //   y: {
          //     formatter: function(val) {
          //       return "$ " + val + " thousands";
          //     },
          //   },
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
      };
    },
  },
  methods: {
    formatNumber(num) {
      let value = parseFloat(num || 0);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(2), 2);
      if (isNaN(value)) {
        return value;
      } else {
        return Math.round(value);
      }
    },
  },
};
</script>

<style lang="scss">
.apexcharts-tooltip {
  background: var(--color-secondary-light) !important;
  color: var(--font-color) !important;
  border: 1px solid var(--border-color) !important;

  & .apexcharts-tooltip-title {
    color: var(--font-color) !important;
    background: var(--color-secondary-light) !important;
    border-bottom: 1px solid var(--border-color) !important;
  }
}
.distribution-card {
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
  margin: 5px 10px;
  background: var(--color-secondary);
  border-radius: 5px;

  .title {
    padding: 0 10px;
  }

  .selection-chits {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    margin: 0 10px;

    span {
      padding: 2px 10px;
      font-size: 0.9em;
      background: var(--color-secondary-light);
      border-radius: 15px;
      margin-left: 5px;
      opacity: 0.7;
      text-transform: capitalize;

      &:first-child {
        margin-left: 0;
      }

      &.active {
        background: var(--color-primary-light);
        color: var(--color-primary);
        opacity: 1;
      }

      &:hover {
        cursor: pointer;
        opacity: 1;
      }
    }
  }

  #chart {
    color: var(--font-color);
    padding: 0 0 0 5px;
  }
}
</style>
